const state = {
    vacancy_title: null,
    vacancy_city: null
};

const mutations = {
    GET_VACANCY_INFO(state, data) {
        state.vacancy_title = data?.title;
        state.vacancy_city = data?.city;
    }
};

const actions = {
    searchVacancies({ commit }, data) {
        commit('GET_VACANCY_INFO', data);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
